import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import serviceHero from "../assets/service-hero.jpg";
import "../styles/ServiceHero.css";

const features = [
  { icon: "fa-solid fa-circle-check",  label: "Accurate",  sub: "Results"       },
  { icon: "fa-regular fa-clock",       label: "Quick",     sub: "Turnaround"    },
  { icon: "fa-solid fa-shield-halved", label: "Safe &",    sub: "Reliable"      },
  { icon: "fa-solid fa-user-group",    label: "Expert",    sub: "Professionals" },
  { icon: "fa-solid fa-microchip",     label: "Advanced",  sub: "Technology"    },
];

export default function ServiceHero() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.08 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={`svh-section${visible ? " svh-visible" : ""}`} ref={sectionRef}>

      {/* ── RIGHT: straight-edge panel ── */}
      <div className="svh-right-bg" aria-hidden="true">
        <div className="svh-img-wrap">
          <img src={serviceHero} alt="TANBIO Diagnostic Services" loading="lazy" className="svh-hero-img" />
        </div>
      </div>

      {/* ── Overlay: spans full section left → right panel edge, fades into image ── */}
      <div className="svh-img-overlay" aria-hidden="true" />

      {/* ── LEFT: content column ── */}
      <Container fluid className="svh-container px-4 px-lg-5">
        <div className="svh-inner">
          <Row className="w-100">
            <Col xs={12} lg={8} xl={7} className="svh-left-col">

              <span className="svh-eyebrow">OUR SERVICES</span>

              <h1 className="svh-headline">
                Comprehensive Diagnostic<br/>
                <span className="ch-heading-highlight">Solutions Under One Roof</span>
              </h1>

              {/* <h1 className="svh-headline">
                Comprehensive Diagnostic<br/>
                <span className="ch-heading-highlight">Solutions Under One Roof</span>
              </h1> */}

              <p className="svh-desc">
                From routine blood tests to advanced genomic analysis, we provide
                accurate, reliable and timely results for better healthcare.
              </p>

              <div className="svh-features">
                {features.map((f) => (
                  <div className="svh-feature-item" key={f.label + f.sub}>
                    <div className="svh-feature-icon-wrap">
                      <i className={f.icon}></i>
                    </div>
                    <div className="svh-feature-text">
                      <span className="svh-feature-label">{f.label}</span>
                      <span className="svh-feature-sub">{f.sub}</span>
                    </div>
                  </div>
                ))}
              </div>

            </Col>
          </Row>
        </div>
      </Container>

    </section>
  );
}